import React from "react";
import { CircularProgress, Typography } from "@mui/joy";
import PageStatus from "./PageStatus";

interface PageLoadingProps {
  children?: React.ReactNode;
  message?: string;
}

const PageLoading: React.FC<PageLoadingProps> = ({
  children,
  message = "Loading...",
}) => {
  return (
    <PageStatus>
      <CircularProgress className="page-status-icon" />
      <Typography level="title-lg" className="page-status-text">
        {children || message}
      </Typography>
    </PageStatus>
  );
};

export default PageLoading;
